import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';

export const getPayFactors = async (reportId: number): Promise<any> => {
  try {
    const config = {
      url: `dataload/factor?reportId=${reportId}`,
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error fetching pay factors:', error);
    throw error;
  }
};
